import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs';
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from '../constants/app.constants';

@Injectable({
  providedIn: 'root'
})
export class NavigationRoutesService {

    private readonly router = inject(Router);
    private readonly destroyRef = inject(DestroyRef);

    private readonly _currentRoute = signal<string>('');
    private readonly _hideMenu = signal<boolean>(false);
    private readonly _hideHeader = signal<boolean>(false);

    constructor() {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        tap(event => {
          const route = (event.url).replace('/', '');
          this._currentRoute.set(route);
          this.updateVisibility(route);
        }),
        takeUntilDestroyed(this.destroyRef)
      ).subscribe();
    }

    getCurrentRoute(): string {
      return this._currentRoute();
    }

    /** @deprecated Use getHideMenu() or getHideHeader() instead */
    getHideMenuAndHeader(): boolean {
      return this._hideMenu();
    }

    getHideMenu(): boolean {
      return this._hideMenu();
    }

    getHideHeader(): boolean {
      return this._hideHeader();
    }

    private updateVisibility(currentRoute: string): void {
      // Backoffice read-only user views open in their own window: content only.
      if (currentRoute.startsWith(`${PRIVATE_ROUTES.admin}/view/`)) {
        this._hideMenu.set(true);
        this._hideHeader.set(true);
        return;
      }
      if (currentRoute.startsWith(PRIVATE_ROUTES.admin)) {
        this._hideMenu.set(true);
        this._hideHeader.set(false);
        return;
      }
      switch(currentRoute){
        case PRIVATE_ROUTES.specificSignIn:
        case PUBLIC_ROUTES.login:
        case PUBLIC_ROUTES.signIn:
          this._hideMenu.set(true);
          this._hideHeader.set(true);
          break;
        case PRIVATE_ROUTES.calendar:
        case PRIVATE_ROUTES.notifications:
        case PRIVATE_ROUTES.messages:
        case PRIVATE_ROUTES.profile:
        case PRIVATE_ROUTES.settings:
        case PRIVATE_ROUTES.subscription:
        case PRIVATE_ROUTES.visitorReport:
        case PRIVATE_ROUTES.clinicToday:
        case PRIVATE_ROUTES.myVisits:
          this._hideMenu.set(false);
          this._hideHeader.set(false);
          break;
        default:
          this._hideMenu.set(true);
          this._hideHeader.set(true);
          break;
      }
    }
}
